// extracted by mini-css-extract-plugin
export var avatar = "_pz-3";
export var avatarContainer = "_pz-2";
export var avatarSpacer = "_pz-5";
export var avatarSpacerContainer = "_pz-4";
export var avatarStackContainer = "_pz-1";
export var bubble = "_pz-0";
export var remainderBubble = "_pz-6";